import ClickLink from './ClickLink';

export default ClickLink;
